"use client";
import React, {useEffect, useRef, useState} from "react";
import {useTheme} from "next-themes";
import dynamic from "next/dynamic";

const LazyCalendlyWidget = dynamic(() => import("react-calendly").then((mod) => mod.InlineWidget), {
    ssr: false,
    loading: () => <p>Loading...</p> // Optional: Show loading text while Calendly widget loads
});

const CalendlyEmbed = () => {
    const theme = useTheme();
    const [isVisible, setIsVisible] = useState(false);
    const calendarRef = useRef(null);

    const darkModeCalendar = theme.theme === "dark" ? {
        backgroundColor: "#000",
        textColor: "#fff",
        primaryColor: "#fff"
    } : {};

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {threshold: 0.1}
        );
        if (calendarRef.current) {
            observer.observe(calendarRef.current);
        }
        return () => {
            if (calendarRef.current) {
                observer.disconnect();
            }
        };
    }, []);

    return (
        <>
            <div className="w-full px-1">
                <div ref={calendarRef}>
                    {isVisible && (
                        <LazyCalendlyWidget
                            url="https://calendly.com/abhinandan-althire-ai"
                            styles={{height: "650px"}}
                            pageSettings={{
                                ...darkModeCalendar,
                                hideLandingPageDetails: false,
                                hideGdprBanner: true,
                                hideEventTypeDetails: false
                            }}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default CalendlyEmbed;
